import { Close, Save } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Autocomplete, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonButton from 'components/ArgonButton'
import ArgonInput from 'components/ArgonInput'
import ArgonTypography from 'components/ArgonTypography'
import { postDataWithResponse } from 'global/postFunc'
import { postSubmit } from 'global/postFunc'
import React, { useEffect, useState } from 'react'

const TambahUser = ({
    open,
    handleClose,
    addReq,
    decryptedUser,
    updating,
    setUpdating
}) => {
    const [saving, setSaving] = useState(false)

    const [username, setUsername] = useState('')
    const [nama, setNama] = useState('')
    const [nip, setNip] = useState('')
    const [password, setPassword] = useState('')

    const [opd, setOpd] = useState({})
    const [listOpd, setListOpd] = useState([])
    const [loading, setLoading] = useState(false)

    const submit = (e) => {
        const formData = {
            kd_pd: opd.kd_pd,
            nip: nip,
            nama: nama,
            username: username,
            password: password
        }

        addReq()
        e.preventDefault();
        setSaving(true)
        postSubmit(
            '/sa/users/admin-opd-insert',
            formData,
            decryptedUser,
            (res) => {
                setSaving(false)
                handleClose()
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                handleClose()
            }
        )
    }

    const reqOpd = () => {
            setLoading(true)
            postDataWithResponse(
                '/opd/filter',
                {
                    jenis: '',
                    nama: '',
                },
                null,
                (res) => {
                    console.log(res);
                    setListOpd(res)
                    setLoading(false)
                },
                (res) => {
                    console.log(res)
                    setLoading(false)
                }
    
            )
        }

    useEffect(() => {
        if (open) {
            reqOpd();
        }
    }, [open])

    return (
        <Dialog
            open={open}
            maxWidth="md"
            fullWidth
            // scroll='paper'
            p={3}
            component='form'
            onSubmit={submit}
        >
            <DialogTitle>
                <ArgonTypography variant='body2' fontWeight="bold">Tambah Admin OPD</ArgonTypography>
            </DialogTitle>
            <DialogContent p={3}>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            OPD
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <Autocomplete
                            id="combo-box-demo"
                            options={listOpd}
                            fullWidth
                            required
                            getOptionLabel={(option) => option.kd_pd + ' ' + option.nama_pd}
                            onChange={(event, newValue) => {
                                newValue !== null && setOpd(newValue)
                            }}
                            onInputChange={(event, newInputValue) => {
                                newInputValue === "" && setOpd({})
                                // newInputValue.length > 7 && reqDpt()
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputProps={{
                                        ...params.InputProps,
                                        required: true,
                                        endAdornment: (
                                            <>
                                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                        />
                    </ArgonBox>
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Nama
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={nama}
                        onChange={(e) => setNama(e.target.value)}
                        autoComplete='off'
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            NIP
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={nip}
                        onChange={(e) => setNip(e.target.value)}
                        autoComplete='off'
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Username
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        autoComplete='off'
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Password
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete='off'
                    />
                </ArgonBox>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                    <Grid item>
                        <ArgonButton color='info' variant='outlined' size="small" startIcon={<Close />} onClick={handleClose}>Batal</ArgonButton>
                    </Grid>
                    <Grid item>
                        <LoadingButton color='info' variant='contained' size="small" startIcon={<Save />} type='submit' loading={saving}>Simpan</LoadingButton>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default TambahUser